import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createAppAlertPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            value: 'select',
            key: 'select',
            align: 'center',
            sortable: false,
            minWidth: 20,
            width: 20,
            cellProps: { class: 'px-0' },
            headerProps: { class: 'px-0' },
        },
        { title: t('appAlerts.date'), value: 'created_at', key: 'created_at', align: 'start', sortable: true, nowrap: true, headerProps: { class: 'nowrap' } },
        { title: t('appAlerts.code'), value: 'code', key: 'code', align: 'start', sortable: false, nowrap: true, headerProps: { class: 'nowrap' } },
        { title: t('appAlerts.count'), value: 'count', key: 'count', align: 'start', sortable: false, nowrap: true, headerProps: { class: 'nowrap' } },
        {
            title: t('appAlerts.text'),
            value: 'text',
            key: 'text',
            align: 'start',
            sortable: false,
            cellProps: { style: 'min-width: 400px;' },
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('appAlerts.dism'),
            value: 'isDismissed',
            key: 'isDismissed',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('appAlerts.dismTooltip'), class: 'nowrap' },
        },
        {
            title: t('appAlerts.check'),
            value: 'isInvestigate',
            key: 'isInvestigate',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('appAlerts.checkTooltip'), class: 'nowrap' },
        },
        {
            title: t('appAlerts.comment'),
            value: 'comment',
            key: 'comment',
            align: 'start',
            sortable: false,
            cellProps: { style: 'min-width: 420px;' },
            headerProps: { class: 'nowrap' },
        },
        { title: t('appAlerts.user'), value: 'userName', key: 'userName', align: 'start', sortable: false, nowrap: true, headerProps: { class: 'nowrap' } },
        { title: '', value: 'actions', key: 'actions', align: 'end', sortable: false, nowrap: true, width: 48, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
